import React from 'react';
import { ChefHat, Package, BarChart2, ShoppingBasket } from 'lucide-react';
import { motion } from 'framer-motion';

interface NavigationProps {
  currentView: string;
  onViewChange: (view: 'menu' | 'products' | 'statistics' | 'shopping') => void;
}

export const Navigation: React.FC<NavigationProps> = ({ currentView, onViewChange }) => {
  return (
    <nav className="flex gap-2">
      <NavButton
        icon={<ChefHat size={20} />}
        label="Menús"
        isActive={currentView === 'menu'}
        onClick={() => onViewChange('menu')}
      />
      <NavButton
        icon={<Package size={20} />}
        label="Productos"
        isActive={currentView === 'products'}
        onClick={() => onViewChange('products')}
      />
      <NavButton
        icon={<BarChart2 size={20} />}
        label="Estadísticas"
        isActive={currentView === 'statistics'}
        onClick={() => onViewChange('statistics')}
      />
      <NavButton
        icon={<ShoppingBasket size={20} />}
        label="Lista"
        isActive={currentView === 'shopping'}
        onClick={() => onViewChange('shopping')}
      />
    </nav>
  );
};

interface NavButtonProps {
  icon: React.ReactNode;
  label: string;
  isActive: boolean;
  onClick: () => void;
}

const NavButton: React.FC<NavButtonProps> = ({ icon, label, isActive, onClick }) => (
  <motion.button
    whileHover={{ scale: 1.05 }}
    whileTap={{ scale: 0.95 }}
    onClick={onClick}
    className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-colors ${
      isActive
        ? 'bg-orange-500 text-white'
        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
    }`}
  >
    {icon}
    {label}
  </motion.button>
);